/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Work_0_BadgeInputs */

const en_svc_ai_agent_development_work_0_badge = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI learning companion`)
};

const ar_svc_ai_agent_development_work_0_badge = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رفيق تعلم ذكاء اصطناعي`)
};

const bn_svc_ai_agent_development_work_0_badge = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI লার্নিং কমপ্যানিয়ন`)
};

const de_svc_ai_agent_development_work_0_badge = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Lernbegleiter`)
};

const es_svc_ai_agent_development_work_0_badge = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compañero de aprendizaje de IA`)
};

const fr_svc_ai_agent_development_work_0_badge = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compagnon d'apprentissage de l'IA`)
};

const pt_svc_ai_agent_development_work_0_badge = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companheiro de aprendizagem de IA`)
};

const zh_svc_ai_agent_development_work_0_badge = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI学习伴侣`)
};

const tr_svc_ai_agent_development_work_0_badge = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapay zeka öğrenim arkadaşı`)
};

const ru_svc_ai_agent_development_work_0_badge = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компаньон для обучения искусственному интеллекту`)
};

const pl_svc_ai_agent_development_work_0_badge = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Towarzysz w nauce AI`)
};

/**
* | output |
* | --- |
* | "AI learning companion" |
*
* @param {Svc_Ai_Agent_Development_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_work_0_badge = /** @type {((inputs?: Svc_Ai_Agent_Development_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_work_0_badge(inputs)
	if (locale === "de") return de_svc_ai_agent_development_work_0_badge(inputs)
	if (locale === "es") return es_svc_ai_agent_development_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_work_0_badge(inputs)
	return en_svc_ai_agent_development_work_0_badge(inputs)
});
export { svc_ai_agent_development_work_0_badge as "svc_ai-agent-development_work_0_badge" }